var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "AutomationSandbox" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("automation.sandboxPage.title")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("automation.sandboxPage.description")))]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "automations-loading" },
          _vm._l(3, function (skltn) {
            return _c(
              "div",
              { key: skltn, staticClass: "automation automation-skeleton" },
              [
                _c("a-skeleton", {
                  attrs: { active: true, paragraph: { rows: 3 } },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm.deletedAutomations.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("delete_outline"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("automation.sandboxPage.emptyState"))),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "automations" },
          _vm._l(_vm.deletedAutomations, function (automation) {
            return _c(
              "div",
              {
                key: automation._id || automation.id,
                staticClass: "automation automation-deleted",
              },
              [
                _c(
                  "div",
                  { staticClass: "automation-header" },
                  [
                    _c("div", { staticClass: "automation-title" }, [
                      _vm._v(
                        _vm._s(
                          automation.name ||
                            _vm.$t("automation.sandboxPage.unnamedAutomation")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-popover",
                      {
                        staticClass: "automation-menu-content",
                        attrs: { trigger: "click" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "automation-menu-popover-items",
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreAutomation(automation)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "undo" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("automation.sandboxPage.restore")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "automation-menu-btn",
                            on: {
                              click: function (e) {
                                return e.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "automation-content" }, [
                  _c(
                    "div",
                    { staticClass: "automation-trigger" },
                    [
                      automation.options &&
                      automation.options.trigger === "timer"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("timer"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.sandboxPage.timerAutomation"
                                  )
                                )
                              ),
                            ]),
                          ]
                        : automation.options &&
                          automation.options.trigger === "event"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("event"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.sandboxPage.eventAutomation"
                                  )
                                ) +
                                  _vm._s(
                                    automation.options.event &&
                                      automation.options.event.type
                                      ? ": " + automation.options.event.type
                                      : ""
                                  )
                              ),
                            ]),
                          ]
                        : automation.options &&
                          automation.options.trigger === "webhook"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("webhook"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("automation.sandboxPage.webhook"))
                              ),
                            ]),
                          ]
                        : automation.options &&
                          automation.options.trigger === "button"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("smart_button"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.sandboxPage.buttonAutomation"
                                  )
                                )
                              ),
                            ]),
                          ]
                        : automation.options &&
                          automation.options.trigger === "table-button"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("smart_button"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.sandboxPage.tableButtonAutomation"
                                  )
                                )
                              ),
                            ]),
                          ]
                        : automation.options &&
                          automation.options.trigger === "chatbot"
                        ? [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("smart_toy"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "automation.sandboxPage.chatbotAutomation"
                                  )
                                )
                              ),
                            ]),
                          ]
                        : [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("settings"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  automation.options &&
                                    automation.options.trigger
                                    ? automation.options.trigger
                                    : _vm.$t("automation.sandboxPage.unknown")
                                )
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  automation.description
                    ? _c("div", { staticClass: "automation-description" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(automation.description) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "automation-meta" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatDeletedDate(automation.deletedAt))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    automation.deletedBy
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getDeletedByText(automation.deletedBy))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("delete_outline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }